<template>
    <UsersTable
            :users="users"
    ></UsersTable>
</template>

<script>
    import { mapState } from 'vuex';
    import UsersTable from "./UsersTable";

    export default {
        name: "UsersTab",

        components: {
            UsersTable
        },

        computed: {
            ...mapState('users', [
                'users',
            ]),

        },

    }
</script>

<style>

</style>